import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Container } from '@mui/material';
import { CalendarToday as CalendarTodayIcon, Event as EventIcon, Group as GroupIcon, Task as TaskIcon, AccountTree as AccountTreeIcon, Ballot as BallotIcon } from "@mui/icons-material";
import { getData } from "../../services/axiosInstance";
import { API_ENDPOINTS } from "../../services/endpoints";
import Loader from "../../common/spinner";
import PushNotificationManager from "../../services/PushNotificationManager";
import DashboardCard from "../../components/common/DashboardCard";

function ManagerDashboard() {
    const navigate = useNavigate();
    const [stats, setStats] = useState({});
    const userDataRaw = localStorage.getItem('userData');
    const userData = userDataRaw ? JSON.parse(userDataRaw) : null;
    const userId = userData?.id;
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            if (!userId) return;
            setLoading(true);
            try {
                const url = `${API_ENDPOINTS.getManagerDashboardCounts}?userId=${userId}`;
                const res = await getData(url);
                if (res.status === "SUCCESS") {
                    setStats(res.message?.data);
                }
            } catch (e) {
                return null;
            }
            finally {
                setLoading(false); // Stop loading regardless of success/fail
            }
        };
        fetchStats();
    }, [userId]);

    const cards = [
        { id: 1, icon: <CalendarTodayIcon />, title: "Total Projects", count: stats.totalProjects, p: "#4158D0", s: "#C850C0", path: "/manager/projects" },
        { id: 2, icon: <AccountTreeIcon />, title: "Total Epics", count: stats.totalEpics, p: "#FBAB7E", s: "#F7CE68", path: "/manager/epic-management" },
        { id: 3, icon: <BallotIcon />, title: "Total Stories", count: stats.totalUserStories, p: "#21D4FD", s: "#B721FF", path: "/manager/stories-management" },
        { id: 4, icon: <TaskIcon />, title: "Tasks to Review", count: stats.totalPendingTasks, p: "#08AEEA", s: "#2AF598", path: "/manager/task-management" },
        {
            id: 5,
            icon: <EventIcon />,
            title: "Attendance Management",
            count: stats.attendanceToday?.percentage
                ? `${parseFloat(stats.attendanceToday?.percentage)}%`
                : "0%",
            p: "#8EC5FC", s: "#E0C3FC",
            path: "/manager/attendance-management"
        },
        { id: 6, icon: <GroupIcon />, title: "Leave Requests", count: stats.totalPendingLeaves, p: "#FF3CAC", s: "#784BA0", path: "/manager/leave-management" }
    ];

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                <Loader />
            </Box>
        );
    }

    return (
        <>
            <PushNotificationManager userId={userId} />
            <Container maxWidth="xl" sx={{ padding: '20px 0 !important' }}>
                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    {cards.map(c => (
                        <Grid key={c.id} size={{ xs: 4, sm: 4, md: 6, lg: 4 }}>
                            <DashboardCard
                                card={c}
                                onClick={() => c.path && navigate(c.path, { state: { openDialog: c.dialog ?? null } })}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Container >
        </>
    );
}

export default ManagerDashboard;